import { Vue, Component, Ref, Prop } from 'vue-property-decorator'

@Component({
    components: {
    }
})
export default class ConceptsModalBasicForm extends Vue {
    @Prop(String) readonly actionTitle!: string
}
